import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Text } from '../text'

import { Color } from '../../theme/color'

import { ReactComponent as CheckedIcon } from '../../assets/ico/common/check/check_checked_blue_fill.svg'
import { ReactComponent as UncheckedIcon } from '../../assets/ico/common/check/check_default_gray_fill.svg'
import { ReactComponent as ArrowIcon } from '../../assets/ico/common/arrow/right/arrow_right_gray-04_medium.svg'

interface TermsBoxProps {
  title: string
  isAgreed: boolean
  onChange: (checked: boolean) => void
  isArrow?: boolean
}

export function TermsBox({ title, isAgreed, onChange, isArrow = true }: TermsBoxProps) {
  const [checked, setChecked] = useState<boolean>(false)

  useEffect(() => {
    setChecked(isAgreed)
  }, [isAgreed])

  const toggle = () => {
    onChange(!checked)
  }

  return (
    <Container checked={checked} onClick={toggle}>
      <CheckboxContainer>
        {checked ? <CheckedIcon /> : <UncheckedIcon />}
        <Text size={18} weight={600}>
          {title}
        </Text>
      </CheckboxContainer>
      {isArrow && <ArrowIcon />}
    </Container>
  )
}

const Container = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ checked }) => (checked ? Color.primary_2 : Color.gray_1)};
  svg {
    flex-shrink: 0;
  }
`

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
